<ul>
  @for (item of menu(); track $index) {
    @if (anchorMenu()) {
      <li>
        <a class="menu-item"
          [class.menu-item--disabled]="item['disabled']"
          [routerLink]="item['route'] ?? './'"
          [fragment]="item['route'] ? undefined : item['fragment']"
          routerLinkActive="menu-item--active"
          [routerLinkActiveOptions]="{ exact: true }">
          <ng-container *ngTemplateOutlet="itemContent; context: { $implicit: item }"></ng-container>
        </a>
      </li>
    } @else {
      <li>
        <a class="menu-item" [class.menu-item--disabled]="item['disabled']">
          <ng-container *ngTemplateOutlet="itemContent; context: { $implicit: item }"></ng-container>
        </a>
      </li>
    }
  }
</ul>

<ng-template #itemContent let-item>
  <ui-inline-svg [name]="item['icon']" class="menu-item-icon"></ui-inline-svg>
  <span class="menu-item-text">{{ item['text'] | transloco }}</span>
  @if (item['underDevelopment']) {
    <ui-under-development position="inline" tooltipPosition="end"></ui-under-development>
  }
</ng-template>
